import Vue from "vue";
import Router from "vue-router";
import HomePage from "./views/HomePage.vue";
import HomePageNoCodeTest from "./views/HomePageNoCodeTest.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: HomePage,
      props: false,
    },
    {
      path: "/nocodes",
      name: "nocodes",
      component: HomePageNoCodeTest,
      props: false,
    },
    {
      path: "*",
      redirect: { name: "home" },
    },
  ],
});

export default router;
